import { DetailPluginLock } from '../basic/interface_lock/DetailPluginLock';
import PaperListOperationService from './service/PaperListOperationService';
import PaperFunctionBarService from './service/PaperFunctionBarService';
import responseKeyNormalizerMapping from './mapping';
export default class PaperDetailPlugin extends DetailPluginLock {
    constructor() {
        super(responseKeyNormalizerMapping.pluginName);
        // @ts-ignore
        this.responseKeyNormalizerMapping = Object.freeze(responseKeyNormalizerMapping);
    }
    _queryParamsNormalizer(route) {
        return super._queryParamsNormalizer(route);
    }
    get basicInfo() {
        return {
            key: this.name,
            index: 1,
            label: `dataType.${this.name}`,
            entryRoute: { name: 'detailPaperRoot' },
        };
    }
    get ListOperationServiceClass() {
        return PaperListOperationService;
    }
    get FunctionBarServiceClass() {
        return PaperFunctionBarService;
    }
    getPluginSubRouteConfig() {
        const self = this;
        function getDetailPageProps(location) {
            return {
                ...self.commonProps,
                ...self._queryParamsNormalizer(location),
            };
        }
        return {
            path: this.name,
            name: 'detailPaperRoot',
            redirect: `${self.PLUGIN_BASIC_PATH}/${this.name}/folders`,
            // @ts-ignore
            component: () => import('./PaperDetail.vue'),
            props: getDetailPageProps,
            children: [
                {
                    path: 'folders',
                    name: 'paperFolderPage',
                    // @ts-ignore
                    component: () => import('./plugin-view/PaperFolder.vue'),
                    props: getDetailPageProps,
                },
            ],
        };
    }
}
